import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Youtube, Mail } from 'lucide-react';

const openCookieSettings = (e) => {
  e.preventDefault();
  try { localStorage.removeItem('bcool_cookie_consent_v1'); } catch (err) { /* ignore */ }
  window.location.reload();
};

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-16 bg-[#0a0a0a] text-gray-300 border-t-4 border-[#c9a961]">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <h4
            className="font-bold tracking-[0.14em] text-white text-3xl mb-1 italic"
            style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
          >
            Bcool<span className="text-[#c9a961]">Store</span>
          </h4>
          <div className="text-[10px] uppercase tracking-[0.4em] text-[#c9a961] font-semibold mb-4">
            — Histoires & Confidences —
          </div>
          <p className="text-[13px] leading-relaxed text-gray-400 max-w-md">
            Un magazine éditorial français qui raconte les histoires vraies, les récits de
            famille et les épreuves qui font grandir. Publié avec soin, sans faux-semblants.
          </p>
          <div className="flex items-center gap-4 mt-6">
            <a href="#" aria-label="Facebook" className="text-gray-300 hover:text-[#c9a961] transition-colors"><Facebook size={17} /></a>
            <a href="#" aria-label="Twitter" className="text-gray-300 hover:text-[#c9a961] transition-colors"><Twitter size={17} /></a>
            <a href="#" aria-label="Instagram" className="text-gray-300 hover:text-[#c9a961] transition-colors"><Instagram size={17} /></a>
            <a href="#" aria-label="YouTube" className="text-gray-300 hover:text-[#c9a961] transition-colors"><Youtube size={19} /></a>
            <a href="mailto:tonywahab234@gmail.com" aria-label="Email" className="text-gray-300 hover:text-[#c9a961] transition-colors"><Mail size={17} /></a>
          </div>
        </div>
        <div>
          <h5 className="uppercase text-[11px] font-bold tracking-[0.24em] text-[#c9a961] mb-4">Rubriques</h5>
          <ul className="space-y-2.5 text-[13px]">
            <li><Link to="/category/chroniques" className="hover:text-[#c9a961] transition-colors">Chroniques</Link></li>
            <li><Link to="/category/lecons-de-vie" className="hover:text-[#c9a961] transition-colors">Leçons de vie</Link></li>
            <li><Link to="/category/fables" className="hover:text-[#c9a961] transition-colors">Fables</Link></li>
            <li><Link to="/category/art-de-vivre" className="hover:text-[#c9a961] transition-colors">Art de vivre</Link></li>
          </ul>
        </div>
        <div>
          <h5 className="uppercase text-[11px] font-bold tracking-[0.24em] text-[#c9a961] mb-4">Informations</h5>
          <ul className="space-y-2.5 text-[13px]">
            <li><Link to="/a-propos" className="hover:text-[#c9a961] transition-colors">À propos</Link></li>
            <li><Link to="/contact" className="hover:text-[#c9a961] transition-colors">Contact</Link></li>
            <li><Link to="/mentions-legales" className="hover:text-[#c9a961] transition-colors">Mentions légales</Link></li>
            <li><Link to="/politique-confidentialite" className="hover:text-[#c9a961] transition-colors">Confidentialité</Link></li>
            <li><Link to="/cookies" className="hover:text-[#c9a961] transition-colors">Politique cookies</Link></li>
            <li><Link to="/cgu" className="hover:text-[#c9a961] transition-colors">Conditions d&apos;utilisation</Link></li>
            <li><a href="#" onClick={openCookieSettings} className="hover:text-[#c9a961] transition-colors">Gérer les cookies</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1280px] mx-auto px-4 md:px-8 py-5 flex flex-col md:flex-row items-center justify-between text-[12px] text-gray-500 gap-2">
          <div>© {year} BcoolStore. Tous droits réservés.</div>
          <div className="text-[11px] uppercase tracking-[0.2em] text-gray-600">
            Écrit avec <span className="text-[#8b2c3f]">♥</span> à Lyon
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
